<div class="banner-carousel">
  <ngb-carousel>
    <ng-template ngbSlide>
      <div class="banner-img-wrapper" style="background-image: url(../assets/img/banners/image011_A06_1920x780.jpg);">
      </div>
      <div class="carousel-caption left-caption">
        <div class="bg-image-bar-info main-bar p-5">
          <h3>Business Management</h3>
          <p class="py-4 fw-bolder">
            Sage 300 is an end-to end business management solution that unlocks your company's potential, reduce costs
            and improve performance with enhanced business visibility.
          </p>
          <a class="btn btn-lg explore-btn" routerLink="/products/sage300">Explore Sage
            300</a>
        </div>
      </div>
    </ng-template>

    <ng-template ngbSlide>
      <div class="banner-img-wrapper" style="background-image: url(../assets/img/banners/image010_A013_1920x780.jpg);">
      </div>
      <div class="carousel-caption left-caption">
        <div class="bg-image-bar-info main-bar p-5">
          <h3>Customer Relationship Management</h3>
          <p class="py-4 fw-bolder">
            Sage CRM is a customer relationship management software, you have the tools to find new customers, reduce
            sales cycles, and build lasting, more profitable relationships.
          </p>
          <a class="btn btn-lg explore-btn" routerLink="/products/sagecrm">Explore Sage
            CRM</a>
        </div>
      </div>
    </ng-template>

    <ng-template ngbSlide>
      <div class="banner-img-wrapper" style="background-image: url(../assets/img/banners/image010_A012_1920x780.jpg);">
      </div>
      <div class="carousel-caption left-caption">
        <div class="bg-image-bar-info main-bar p-5">
          <h3>HR &amp; Payroll</h3>
          <p class="py-4 fw-bolder">
            Sage People is a comprises an agile, innovative and cost-effective HR solution that effortlessly and
            powerfully processes HR and payroll functions in your business.
          </p>
          <a class="btn btn-lg explore-btn" routerLink="/products/sagecrm">Explore Sage
            People</a>
        </div>
      </div>
    </ng-template>

  </ngb-carousel>
</div>


<div class="bg-dark-green text-white d-flex align-items-center card-transparent card-center">
  <div class="container">
    <div class="d-flex p-2 text-center justify-content-center">
      <h4 class="service-heading">
        Microtek Informa Solusindo offer various services to help you
      </h4>
    </div>

    <div class="card-group d-flex flex-wrap gap-3">

      <div class="card border-0 flex-fill service-card">
        <img src="../assets/img/sage-book-tag-white.svg" alt="Training" />
        <div class="card-body">
          <h6 class="card-title">Training</h6>
        </div>
      </div>

      <div class="card border-0 flex-fill service-card">
        <img src="../assets/img/sage-people-chat-white.svg" alt="Consultancy" />
        <div class="card-body">
          <h6 class="card-title">Consultancy</h6>
        </div>
      </div>

      <div class="card border-0 flex-fill service-card">
        <img src="../assets/img/sage-financial-app-white.svg" alt="Cost-Saving" />
        <div class="card-body">
          <h6 class="card-title">Cost Saving</h6>
        </div>
      </div>

      <div class="card border-0 flex-fill service-card">
        <img src="../assets/img/sage-rapid-white.svg" alt="Improvement" />
        <div class="card-body">
          <h6 class="card-title">Improvement</h6>
        </div>
      </div>

      <div class="card border-0 flex-fill service-card">
        <img src="../assets/img/sage-app-checked-white.svg" alt="Implementation" />
        <div class="card-body">
          <h6 class="card-title">Implementation</h6>
        </div>
      </div>


    </div>

  </div>
</div>


<div class="container">
  <div class="py-5 d-flex flex-wrap gap-4 justify-content-center align-items-center card-center">
    <div class="d-flex award-card-wrap">
      <!-- Platinum Partner -->
      <div class="card border-0 h-100 w-100">
        <img src="../assets/img/awards/logo-platinum-elite.png" class="award-image" alt="Sage Platinum Elite" />
        <div class="card-body">
          <h5 class="card-title">#1 Asia Platinum Elite Partner for Sage</h5>
        </div>
      </div>
    </div>

    <div class="d-flex award-card-wrap">
      <!-- Partner -->
      <div class="card border-0 h-100 w-100">
        <img src="../assets/img/awards/logo-partner.png" class="award-image" alt="Sage Partner" />
        <div class="card-body">
          <h5 class="card-title">#1 Indonesia Partner for Sage</h5>
        </div>
      </div>
    </div>

    <div class="d-flex award-card-wrap">
      <!-- Diamond Partner -->
      <div class="card border-0 h-100 w-100">
        <img src="../assets/img/awards/logo-sage-platinum.png" class="award-image award-image-sm" alt="Platinum Partner" />
        <div class="card-body">
          <h5 class="card-title">Sage Platinum Partner</h5>
        </div>
      </div>
    </div>

    <div class="d-flex award-card-wrap">
      <!-- Sage Awards -->
      <div class="card border-0 h-100 w-100">
        <img src="../assets/img/awards/logo-awards-superbrand.png" class="award-image" alt="Superbrand Award" />
        <div class="card-body">
          <h5 class="card-title">Sage Superbrands Status 2019</h5>
        </div>
      </div>
    </div>

    <div class="d-flex award-card-wrap">
      <div class="card border-0 h-100 w-100">
        <img src="../assets/img/awards/logo-award_temkin-2017.png" class="award-image" alt="Temkin Award" />
        <div class="card-body">
          <h5 class="card-title">Sage Temkin Group Customer Experience Award 2017</h5>
        </div>
      </div>
    </div>

    <div class="d-flex award-card-wrap">
      <div class="card border-0 h-100 w-100">
        <img src="../assets/img/awards/logo-pcmac-award.png" class="award-image" alt="PC Magazine" />
        <div class="card-body">
          <h5 class="card-title">PC Magazine Business Choice Award</h5>
        </div>
      </div>
    </div>

  </div>
</div>
